import { render, staticRenderFns } from "./EventEnd.vue?vue&type=template&id=e274200a"
import script from "./EventEnd.vue?vue&type=script&lang=js"
export * from "./EventEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports